import classnames from 'classnames'
import { IResponse } from 'marketing-site/pages/api/forms/submit'
import { MarketoFormV2 } from 'marketing-site/src/library/components/MarketoFormV2'
import { Image } from 'marketing-site/src/library/elements/Image'
import { RichText } from 'marketing-site/src/library/elements/RichText'
import { Text } from 'marketing-site/src/library/elements/Text'
import React, { useState } from 'react'
import { CTAButton } from '../../elements/CTAButton'
import { CTALink } from '../../elements/CTALink'
import checkmark from '../../images/checkmark.svg'
import magicLineBottom from '../../images/magic-line-bottom.png'
import magicLineTop from '../../images/magic-line-top.png'
import { LegacyColor, LegacyColorName, getColorTheme } from '../../utils'
import { IProps } from './index'
import styles from './styles-legacy.scss'
import { NewBrandingHoc } from 'marketing-site/src/library/utils/NewBrandingHoc'
import { ContentDownload as ContentDownloadDefault } from './component'
enum StepStates {
  CTA = 'cta',
  Form = 'form',
  Confirmation = 'confirmation',
}

function ContentDownloadLegacy({
  heading,
  image,
  stepOneHeader,
  stepOneListHeader,
  stepOneListItems,
  stepOneCTAText,
  stepTwoHeader,
  stepTwoMarketoFormID,
  stepThreeHeaderIcon,
  stepThreeHeader,
  stepThreeCTAText,
  stepThreeDownloadURL,
  backgroundColor,
  imageIllustrationOverlays,
}: IProps) {
  const [stepState, setStepState] = useState<StepStates>(StepStates.CTA)

  const handleFormSubmit = (formSubmitResponse: IResponse) => {
    if (formSubmitResponse.success) {
      setStepState(StepStates.Confirmation)
    }
  }

  const colorTheme = getColorTheme('legacy', backgroundColor)

  const wrapperClasses = classnames(
    'content-download',
    `content-download--bg-${LegacyColorName[colorTheme.backgroundColor as LegacyColor]}`,
    `content-download--step-${stepState}`,
  )

  const imageClasses = classnames('content-download__left', {
    'content-download__left--no-illustrations': !imageIllustrationOverlays,
  })

  return (
    <div className={wrapperClasses}>
      <div className="content-download__inner">
        <div className="content-download__top">
          <Text size="xxl+">{heading}</Text>
          <div className="subheader">
            <Text size="lg">
              <RichText document={stepOneHeader}></RichText>
            </Text>
          </div>
        </div>
        <div className={imageClasses}>
          {imageIllustrationOverlays && (
            <img className="magic-line-top" src={magicLineTop} alt="" />
          )}
          <Image {...image} />
          {imageIllustrationOverlays && (
            <img className="magic-line-bottom" src={magicLineBottom} alt="" />
          )}
        </div>
        <div className="content-download__right">
          {/* Step One */}
          {stepState === StepStates.CTA && (
            <div className="content-download__step-cta">
              <div className="subheader">
                <Text size="lg">
                  <RichText document={stepOneHeader}></RichText>
                </Text>
              </div>
              <div className="checklist">
                {stepOneListHeader && <Text size="caption+">{stepOneListHeader}</Text>}
                {stepOneListItems &&
                  stepOneListItems.map((item, key) => (
                    <div key={key} className="checklist__item">
                      <img className="checklist__img" src={checkmark} alt="" />
                      <p className="checklist__text">{item}</p>
                    </div>
                  ))}
              </div>
              <CTAButton
                onClick={() => setStepState(StepStates.Form)}
                bgColor={colorTheme.CTATheme}
                text={stepOneCTAText}
              ></CTAButton>
            </div>
          )}
          {/* Step Two */}
          {stepState === StepStates.Form && (
            <div className="content-download__step-form">
              {stepTwoHeader && (
                <Text size="lg">
                  <RichText document={stepTwoHeader}></RichText>
                </Text>
              )}
              <div className="form-container">
                <MarketoFormV2
                  formId={stepTwoMarketoFormID}
                  submitButtonLabel={'Download now'}
                  onSubmit={handleFormSubmit}
                  forceBusinessEmail={false}
                />
              </div>
            </div>
          )}
          {/* Step Three */}
          {stepState === StepStates.Confirmation && (
            <div className="content-download__step-confirmation">
              {stepThreeHeaderIcon && (
                <img className="confirmation-icon" src={stepThreeHeaderIcon} alt="" />
              )}
              {stepThreeHeader && (
                <Text size="lg">
                  <RichText document={stepThreeHeader}></RichText>
                </Text>
              )}
              {stepThreeCTAText && stepThreeDownloadURL && (
                <div className="cta">
                  <CTALink
                    bgColor={colorTheme.CTATheme}
                    url={stepThreeDownloadURL}
                    text={stepThreeCTAText}
                  ></CTALink>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <style jsx>{styles}</style>
      <style jsx>{`
        .content-download {
          background-color: ${colorTheme.backgroundColor};
          color: ${colorTheme.textColor};
        }
      `}</style>
    </div>
  )
}

export const ContentDownload = NewBrandingHoc(ContentDownloadLegacy, ContentDownloadDefault)
